const getters = {
  // 调用后台的http url的ip和端口
  baseUrl: state => state.app.baseUrl,

  // 顶部进度条控制参数
  area: state => state.loading.area,

  // 路由数据
  routers : state => state.menuStore.routers,

    // tabs view
    visitedViews: state => state.tagsView.visitedViews,
    cachedViews: state => state.tagsView.cachedViews,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js